module.exports = __webpack_public_path__ + "img/pic.d6aa8a11.png";